<template>
  <div>
    <h2 class="text-center text-space">{{ translatedFields['result'] }}</h2>
    <p class="result"  v-html="getResults"> </p>
  </div>
</template>

<script>

export default {
  props: {
  },
  data () {
    return {
      translatedFields: '',
      fields_en: {
        result: 'Result'
      }
    }
  },
  computed: {
    getResults () {
      if (this.$store.state.matchUser.result) {
        return this.$store.state.matchUser.result
      }
    },
    language () {
      this.checkLanguage()
      return this.$store.state.lang.value
    },
    spanishFields () {
      return this.$store.state.translation_es
    },
    chineseFields () {
      return this.$store.state.translation_zh
    }
  },
  watch: {
    language () {
      this.checkLanguage()
    }
  },
  methods: {
    checkLanguage () {
      if (this.$store.state.lang.value === 'ES') {
        this.translatedFields = this.$store.state.translation_es
      } else {
        if (this.$store.state.lang.value === 'ZH') {
          this.translatedFields = this.$store.state.translation_zh
        } else {
          this.translatedFields = this.fields_en
        }
      }
    }
  }
}
</script>

<style scoped>
.result{
  text-align: center;
  font-size: 20px;
  position: relative;
}

>>>.download-final-report {
  position: absolute;
  bottom: -50px;
  width: 230px;
  right: 0;
  color: #323737;
  cursor: pointer;
  border: 2px solid #31bebf;
  border-radius: 20px;
  z-index: 1;
  font-size: 18px;
}

@media all and (max-width: 1000px) {
  >>>.download-final-report {
    width: 200px;
    bottom: -50px;
    right: -5px;
    font-size: 16px;
  }
}

@media all and (max-width: 400px) {
  >>>.download-final-report {
    width: 190px;
    bottom: -40px;
    right: 50px;
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PatientMatch/Wizard/Result.vue